import { useEffect } from 'react';

import subscribeUser from 'Helper/subscribeUser';
import { useUserInfo } from 'Store/userInfo';

const RegisterServiceWorker = ({ children }) => {
  const { token } = useUserInfo();

  useEffect(() => {
    let subscribe;
    if ('serviceWorker' in navigator && token) {
      navigator.serviceWorker
        .register('/sw.js')
        .then(async (reg) => {
          reg.update();
          subscribe = subscribeUser();
        })
        .catch((error) => {
          console.log('Service workers failed to register', error);
        });

      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event?.data?.type === 'playAudio') {
          const audioNotif = new Audio('/sound-notification.mp3');
          audioNotif.play();
        }
      });
    }

    return () => {
      if (subscribe && 'serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then((reg) => {
          reg.pushManager.getSubscription().then((subscription) => {
            subscription?.unsubscribe();
          });
        });
      }
    };
  }, [token]);

  return children;
};

export default RegisterServiceWorker;
